// eslint-disable-next-line
import React from "react";
import { history } from "../../_redux/_store/history";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import SearchIcon from "@material-ui/icons/Search";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import {Table,TableBody,TableCell,TableContainer,TableRow,Paper} from "@material-ui/core";
import MuiTableHead from "@material-ui/core/TableHead";
import {
  Button,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  makeStyles,
  Grid,
  Chip,
  Snackbar,
} from "@material-ui/core";
import queryString from "query-string";
import {withStyles } from "@material-ui/styles";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorHandler from "../updateHandlers/ErrorHandler";
import Autocomplete from "@material-ui/lab/Autocomplete";
import useDebounce from "../../utilities/useDebounce";
import FooterPagination from "../_footerpagination/FooterPagination";
import { fetchSpecificAnomalyRule } from '../../_redux/_actions/selectScopedAnomalyRuleAction'
import {
  clearAnomalyState,
  fetchSignals,
} from "../../_redux/_actions/anomalyRuleActions";
import { createAnomalyRule } from "../../_redux/_actions/anomalyRuleActions";
import {
  fetchFunction,
  fetchNode,
} from "../../_redux/_actions/scopedFindingRuleActions";
import SkeletonTableList from '../skeleton/SkeletonTableList.jsx'
import axios from 'axios';

const useStyles = makeStyles(() => ({
  styleFullWidthDialog:{
    '& .MuiDialog-paper': {
      backgroundColor: "#F6F6F6",
      margin:'unset',
      position:"fixed",
      right:"0"
    },
    '& .MuiDialog-paperScrollPaper ': {
      height: "100%",
      width: "76%",
      maxWidth:"unset",
      maxHeight:"unset"
    },
  },
  alignBottom: {
    alignSelf: "flex-end",
  },
  dialogAction: {
    justifyContent: "flex-start",
  },
  label: {
    fontWeight: "bold",
    margin: "5px",
    marginTop :"20px"
  },
  chip: {
    alignSelf: "flex-end",
    backgroundColor: "white",
    margin: " 5px",
  },
  tableHead: {
    color: "white",
  },
  signalsInput: {
    width: "95%",
    maxHeight: "65px"
  },
  anomalyInput: {
    width: "95%",
    maxHeight: "65px"
  },
  caption: {
    padding: "8px",
  },
  disableSelection: {
    opacity: "0.5",
  },
  FindSignalStyle:{
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#000000',
    marginBottom: '10px'
  },
  requiredField:{
    '& .MuiFormLabel-asterisk':{
      color: '#CE3800'
    }
  },
  containerBox:{
    border: '1px solid #BFB8AF',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '10px'
  },
  searchButton:{
    borderRadius: '4px !important',
    border: '1px solid #AFC3CD',
    boxSizing: 'border-box',
    backgroundColor: '#AFC3CD',
    marginTop: '10px',
    padding: '7px 2px !important',
    '& .MuiButton-label': {
      color: '#FFFFFF',
      textTransform: 'capitalize'
    }
  },
  closeButton:{
    cursor: 'pointer',
    margin:"auto",
    color:'white',
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  },
  divider:{
    backgroundColor: "rgb(38, 37, 35)",
    width: "5%"
  },
  aligningDiv:{
    marginTop:'20px'
  },
}));

const Dialog = withStyles(() => ({
  paper: {
    backgroundColor: "#F6F6F6",
    padding: "30px"
  },
  paperScrollPaper: {
    height: "300",
    width: "1200px"
  },
  paperWidthSm: {
    maxWidth: "1200px",
  }
}))(MuiDialog);

const DialogTitle = withStyles(() => ({
  root: {
    padding: "20px",
  },
}))(MuiDialogTitle);

const DialogContent = withStyles(() => ({
  root: {
    backgroundColor: "white",
    alignSelf: "center",
    padding: "0px",
    overflow: 'visible',
    display: "flex",
    marginTop: '10px',
    marginLeft: '18px',
    width: '95%',
    flexDirection: "column"
  },
}))(MuiDialogContent);

const DialogActions = withStyles(() => ({
  root: {
    justifyContent: "flex-start",
  },
}))(MuiDialogActions);

const TableHead = withStyles(() => ({
  root: {
    backgroundColor: "#666666",
    color: "white",
  },
}))(MuiTableHead);

const Row = (props) => {  
  const { index, signal, handleSelectSignal, disabled } = props;
  return (
    <React.Fragment>
      <TableRow hover>
        <TableCell>{signal.id}</TableCell>
        <TableCell scope="row" style={{ width: "350px" }}>
          {signal.name}
        </TableCell>
        <TableCell align="right">
          <Button
            disabled={disabled}
            color="primary"
            onClick={() => {
              handleSelectSignal(signal, index);
            }}
          >
            +Add
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6} />
      </TableRow>
    </React.Fragment>
  );
};

export const CreateAnomalyRuleComponent = React.memo(({ props ,showFullWidth}) => {
  const {
    handleCloseDialog,
    scroll,
    handleCreateScopedAnomaly,
    anomalyRuleComponent,
    createSuccessFlag,
    initiateFunctionCall
  } = props;
  const classes = useStyles();
  const debounce = useDebounce();
  const rulesPerPage = 8;
  const [page, setPage] = useState(1);
  const [currentPage, setcurrentPage] = useState(1);
  const [currentFiltered, setCurrentFiltered] = useState("");
  const [allSignals, setAllSignals] = useState(null);
  const [filteredSignals, setFilteredSignals] = useState(null);
  const [anomalyTypeList, setAnomalyTypeList] = useState(null);
  const [value, setValue] = useState(null);
  const [anomalyType, setAnomalyType] = useState(null);
  const [cancelToken, setCancelToken] = useState(null)
  const anomalyConfigurationResponse = useSelector(
    (state) => state.anomalyRule
  );
  const [signalIds, setSignalIds] = useState([]);
  const [selectedSignals, setSelectedSignals] = useState([]);
  const [signalselect, setSignalselect] = useState(null);
  const [error, setError] = useState(false);
  const [anomalyTypeId, setAnomalyTypeId] = useState("");
  const [selectedNodeNumber, setselectedNodeNumber] = useState("");
  const [selectedFunctionGroup, setselectedFunctionGroup] = useState("");
  const [showSignalTable, setShowSignalTable] = useState(false);
  const [warning, setWarning] = useState(false);
  const [showCreateAnomalySuccess, setShowCreateAnomalySuccess] = useState(false)
  const dispatch = useDispatch();
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues

  const scopedFindingRuleResponse = useSelector(
    (state) => state.scopedFindingRule
  );
  const typeFilters = useSelector((state) => state.anomalyRule.typeFilters);
  
  const clearStates = () => {
    setError("");
  };

  useEffect(() => {
    initiateFunctionCall && dispatch(
      fetchNode({ machine_type: machine_type, hmi_type: hmi_type })
    );
    if(typeFilters){
      typeFilters.node && setselectedNodeNumber(typeFilters.node) 
      typeFilters.func && setselectedFunctionGroup(typeFilters.func) 
      if(typeFilters.type){
        setAnomalyType(typeFilters.type)
        setAnomalyTypeId(typeFilters.type.id)
      }
    }
    return () => clearStates();
  }, []);

  useEffect(() => {
    if (filteredSignals) {
      const indexOfLastRule = currentPage * rulesPerPage;
      const indexOfFirstRule = indexOfLastRule - rulesPerPage;
      setCurrentFiltered(
        filteredSignals.slice(indexOfFirstRule, indexOfLastRule)
      );
    }
  }, [filteredSignals, currentPage]);

  useEffect(() => {
    if (anomalyConfigurationResponse.signals) {
      const defaultProps = {
        options: anomalyConfigurationResponse.signals,
        getOptionLabel: (option) => (option.name ? option.name : ""),
      };
      setAllSignals(defaultProps);
    }
    if (anomalyConfigurationResponse.anomalyType) {
      const defaultProps = {
        options: anomalyConfigurationResponse.anomalyType,
        getOptionLabel: (option) => (option.id ? option.id : ""),
      };
      setAnomalyTypeList(defaultProps);
    }
  }, [anomalyConfigurationResponse]);

  useEffect(() => {
    if(anomalyConfigurationResponse.signals){
      if (value) {
        const searchArr = value.name.toLowerCase().split(" ");
        let count;
        const filtered = anomalyConfigurationResponse.signals.filter((signal) => {
          count = 0;
          searchArr.forEach((val) => {
            if (signal.name.toLowerCase().includes(val)) {
              count = count + 1;
            }
          });
          return count === searchArr.length;
        });
        setFilteredSignals(
          filtered.sort((a, b) => {
            return a.id - b.id;
          })
        );
      } 
      else if (anomalyConfigurationResponse.signals) {
        setFilteredSignals(
          anomalyConfigurationResponse.signals.sort((a, b) => {
            return a.id - b.id;
          })
        );
      }
    }
  }, [value,anomalyConfigurationResponse,selectedSignals]);

  useEffect(() => {
    if (value) {
      setcurrentPage(1);
      setPage(1);
    }
  }, [value]);

  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber);
  };

  const handleChange = (event, value) => {
    setPage(value);
    paginate(value);
  };

  const handleDeleteSignal = (index) => {
    const arr = [...selectedSignals];
    arr.splice(index, 1);
    setSelectedSignals([...arr]);
    signalIds.splice(index, 1);
    setSignalIds([...signalIds]);
  };

  const handleSelectSignal = (newValue, index) => {
    setSignalIds([...signalIds, newValue.id]);
    setSelectedSignals([...selectedSignals, newValue]);
  };

  const handleSignalChange = (newValue) => {
    setSignalselect(newValue)
    setValue(newValue);
  };

  const handleAnomalyTypeChange = (newValue) => {
    if(newValue){
    setAnomalyType(newValue);
    setAnomalyTypeId(newValue.id);
    }
    else{
      setAnomalyType('');
      setAnomalyTypeId('');
    }
  };

  const handleNodeNumberChange = (newValue) => {
    setselectedNodeNumber(newValue);
    if (newValue ) {
      dispatch(
        fetchFunction({
          machine_type: machine_type,
          hmi_type: hmi_type,
          node_number: newValue.number,
        })
      );
    }   
    setselectedFunctionGroup("");
  };

  const handleFunctionGroupChange = (newValue) => {
    setselectedFunctionGroup(newValue);
  };

  const searchSignals = () =>{
    setFilteredSignals('')
    if(selectedNodeNumber && anomalyTypeId){
      const params={
        machine_type:machine_type,
        ...(hmi_type?{hmi_type:hmi_type}:{}),
        ...(selectedNodeNumber?{node_number:selectedNodeNumber.number}:{}),
        ...(selectedFunctionGroup?{function_number:selectedFunctionGroup.number}:{}),
        ...(anomalyTypeId?{anomaly_type:anomalyTypeId}:{}),
      }
      if (cancelToken !== null) {
        cancelToken.cancel("Operation canceled due to new request.")
      }
      let c = axios.CancelToken.source()
      setCancelToken(c)
      dispatch(fetchSignals(params,c));
    }
    else{
      setWarning(true)
    }
    showFullWidth(true)
    setShowSignalTable(true)
  }

  const handleStatusOfAnomalyCreation = async(status) =>{
    if(status){
      if(createSuccessFlag)
      {
        createSuccessFlag(status) 
      } 
      else {
        setShowCreateAnomalySuccess(true);
        await dispatch(fetchSpecificAnomalyRule(status.id, machine_type, hmi_type));
        handleCloseDialog();
      }
    }
  }

  const handleNext = () => {
    if (anomalyType && signalIds.length > 0) {
      const body = {
        anomaly_type_id: [anomalyType.id],
        signal_ids: signalIds,
      };
      dispatch(createAnomalyRule(body, handleCreateScopedAnomaly, machine_type,hmi_type, handleStatusOfAnomalyCreation));
    } 
    else {
      setError("Select anomaly type and signal!");
    }
  };

  const AnomalyTable = () => {
    const classes = useStyles();
    return (
      <TableContainer>
        <Table aria-label="collapsible table" >
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>Signal ID</TableCell>
              <TableCell className={classes.tableHead}>Signal</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {(anomalyConfigurationResponse.signalsLoading) && <SkeletonTableList count={3}/> }
            {currentFiltered && !anomalyConfigurationResponse.signalsLoading && anomalyType && currentFiltered.length > 0
              ? currentFiltered.map((signal, index) => (
                  <Row
                    key={`signal${signal.id}`}
                    index={index}
                    signal={signal}
                    handleSelectSignal={handleSelectSignal}
                    disabled={signalIds.includes(signal.id)}
                  />
                ))
              : !anomalyConfigurationResponse.signalsLoading?<TableRow
              style={{ height: 10 }}
            >
              <TableCell colSpan={5}>
               No data found
              </TableCell>
            </TableRow>:null}
          </TableBody>
        </Table>

      </TableContainer>
    );
  };

  return (
    <>
      <DialogTitle>
          {!anomalyRuleComponent ? (
            <Grid container justifyContent="space-between" style={{marginBottom: '10px', padding:'0px 10px'}}>
              <Typography
                      variant='h4'
                      style={{ color: '#52A1C2', fontSize: '1.5rem' }}
                    >
                Create New Anomaly Rule
              </Typography>
            </Grid>
          ) : null}
          <Grid className={classes.containerBox}>
            <Grid><div className={classes.FindSignalStyle}>Find Signals</div></Grid>
            <Grid container spacing={2}>
              <Grid item md={3} lg={3} sm={12} xs={12}>
                <Autocomplete
                  className={classes.anomalyInput}
                  disabled={
                    hmi_type && scopedFindingRuleResponse.node.length > 0 && !scopedFindingRuleResponse.nodeLoading ? null : true
                  }
                  options={scopedFindingRuleResponse.node ? scopedFindingRuleResponse.node : []}
                  value={selectedNodeNumber}
                  onChange={(event, newValue) => {
                    handleNodeNumberChange(newValue);
                  }}
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  renderInput={(params) => (
                    <TextField
                      className={classes.requiredField}
                      required = {true}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon color="disabled" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...params}
                      label="Modul"
                    />
                  )}
                />
              </Grid>
              <Grid item  md={3} lg={3} sm={12} xs={12}>
                <Autocomplete
                  className={classes.anomalyInput}
                  disabled={
                    !selectedNodeNumber 
                    //|| scopedFindingRuleResponse.function.length > 0
                  }
                  options={scopedFindingRuleResponse.function ? scopedFindingRuleResponse.function : []}
                  value={selectedFunctionGroup}
                  onChange={(event, newValue) => {
                    handleFunctionGroupChange(newValue);
                  }}
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  renderInput={(params) => (
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon color="disabled" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...params}
                      label="Function Group"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                md={3}
                lg={3}
                sm={12}
                xs={12}
              >
                <Autocomplete
                      className={classes.anomalyInput}
                      options={anomalyTypeList? anomalyTypeList.options : []}
                      getOptionLabel={(option) => (option.id ? option.id : "")}
                      blurOnSelect
                      value={anomalyType}
                      onChange={(event, newValue) => {
                        handleAnomalyTypeChange(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField                     
                        className={classes.requiredField}
                        required = {true} 
                        {...params} 
                        label="Select Anomaly" 
                      />
                      )}
                />
              </Grid>
              <Grid
                item
                md={2}
                lg={2}
                sm={12}
                xs={12}
              >
                <Button className ={classes.searchButton} 
                  disabled ={selectedNodeNumber && (anomalyTypeId || anomalyType) ?  false : true}  
                  onClick={()=> searchSignals()} 
                  variant="contained" 
                  startIcon={<SearchIcon />}
                >
                  Search
                </Button>
              </Grid>
              {showSignalTable && 
                <Grid item
                  md={12}
                  lg={12}
                  sm={12}
                  xs={12}>
                  <Autocomplete
                    className={classes.signalsInput}
                    {...allSignals}
                    disabled={!anomalyConfigurationResponse.signalsLoading && allSignals ? null : true}
                    value={signalselect}
                    onChange={(event, newValue) => {
                        handleSignalChange(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Search Signal" />
                    )}
                  />
                </Grid>
              }
            </Grid>
            {warning && (
            <Snackbar
              message={"Provide all the required filters!"}
              open={warning ? true : false}
              onClose={() => setWarning(false)}
              autoHideDuration={2000}
            />
            )}
            {showSignalTable &&
              <Grid container spacing={4} style={{margin: '0px !important'}}>
                <Grid item  md={2} lg={2} sm={12} xs={12} padding={4} >
                  <Typography variant="body2" className={classes.label}>
                    Signals Added:
                  </Typography>
                </Grid>
                <Grid item  md={10} lg={10} sm={12} xs={12}  container>
                  {selectedSignals.map((signal, index) => {
                    return (
                      <Chip
                        key={`selectedSignal${signal.id}`}
                        className={classes.chip}
                        variant="outlined"
                        size="small"
                        label={signal.name}
                        onDelete={() => handleDeleteSignal(index)}
                      />
                    );
                  })}
                </Grid>
              </Grid>
            }
          <DialogContent >
          {anomalyConfigurationResponse.loading && <SkeletonTableList cols={3} />}
          {anomalyConfigurationResponse.error && (
          <ErrorHandler message={anomalyConfigurationResponse.error} />
          )}
          {anomalyConfigurationResponse.createError && (
            <Snackbar
              message={anomalyConfigurationResponse.createError}
              open={anomalyConfigurationResponse.createError ? true : false}
              onClose={() => dispatch(clearAnomalyState())}
              autoHideDuration={2000}
            />
          )}
          {showSignalTable && <AnomalyTable />}
          {showSignalTable && filteredSignals && anomalyType && filteredSignals.length > 0 ? (
              <FooterPagination
              page={page}
              handleChange={handleChange}
              rulesPerPage={rulesPerPage}
              totalRules={filteredSignals.length}
            />
          ) : null}
        </DialogContent>
        {showSignalTable && 
          <DialogActions>
            <Button
              autoFocus
              className="btn-primary"
              color="primary"
              onClick={() => handleNext()}
            >
              Next
            </Button>
            <Button color="primary" onClick={() => handleCloseDialog()}>
            Cancel
            </Button>
          </DialogActions>
        }
       </Grid>
      </DialogTitle>
      <Snackbar
        message={error}
        open={error ? true : false}
        onClose={() => setError(false)}
        autoHideDuration={3000}
      />
      <Snackbar
        message={"Anomaly Rule Created"}
        open={showCreateAnomalySuccess}
        onClose={() => setShowCreateAnomalySuccess(false)}
        autoHideDuration={2000}
      />
    </>
  );
});

function CreateAnomalyRule(props) {
  const classes = useStyles();
  const [dialogWidth, setFullDialogWidth] = useState(false);

  const showFullWidth = () =>{
    setFullDialogWidth(true)
  }
  
  return (
    < MuiDialog
      tabIndex="false"
      open={props.open}
      scroll={props.scroll}
      className={classes.styleFullWidthDialog}
    >
      <Grid container direction="row" style={{height:"100vh"}}>
        <Grid item className={classes.divider}>
           <div className={classes.aligningDiv}> 
            <CancelRoundedIcon className={classes.closeButton} onClick={() => props.handleCloseDialog()}/>
           </div>
        </Grid>
        <Grid item xs={11} md={11}>
           <CreateAnomalyRuleComponent props={props} showFullWidth={showFullWidth} />
        </Grid>
      </Grid>
    </MuiDialog>
  );
}

export default React.memo(CreateAnomalyRule);
